import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-locked-folder-icon',
  templateUrl: './files-locked-folder.component.html'
})
export class FilesLockedFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
